import { motion, useScroll, useTransform } from "motion/react";
import { cn } from "../../utilities";

import styles from "./header.module.scss";
import { useEffect, useRef, useState } from "react";
import ScanButton from "../common/scanButton/scanButton";

export function Header() {
  const video = useRef(null);
  const [muteVideo, setMuteVideo] = useState(true);

  useEffect(() => {
    if (!video.current) return;
    video.current.play();
  }, [video]);

  // useEffect(() => {
  //   const attachVideoEndListener = () => {
  //     if (!video.current) return;
  //     video.current.addEventListener("ended", () => {
  //       setDisplayCta(true);
  //     });
  //   };

  //   setTimeout(() => {
  //     playHeroVideo(true);
  //     attachVideoEndListener();
  //   }, 1000);
  // }, []);

  const toggleVideoSound = () => {
    if (!video.current) return;
    const muted = video.current.muted;
    video.current.muted = !muted;
    setMuteVideo(!muted);
  };

  return (
    <div className={styles.headerBg}>
      <div className={styles.header} data-tap-disabled="true">
        <motion.div
          className={styles.jacked}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 1, type: "spring", damping: 12, stiffness: 100 }}
        >
          <div className={styles.jackedHeader}>
            {/* <h2>HERE WE</h2>
            <h2>ROAR</h2> */}
            <img src="icons/header-text-2.png" alt="Here We Roar" className={styles.headerTitle} />
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{
                delay: 1.75,
                type: "spring",
                damping: 12,
                stiffness: 100,
              }}
            >
              <h3>
                CALGARY IS <span>DINOS TERRITORY</span>
              </h3>
            </motion.div>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{
                delay: 2.5,
                type: "spring",
                damping: 12,
                stiffness: 100,
              }}
              style={{ marginTop: "16px" }}
            >
              <ScanButton />
            </motion.div>
          </div>
        </motion.div>
        <div className={styles.videoContainer}>
          <video
            playsInline
            autoplay
            loop
            muted
            preload="none"
            id="final8-header"
            className={cn(styles.videoBg)}
            ref={video}
          >
            <source
              src="video/Hero-Portrait.mp4"
              type="video/mp4"
              media="(orientation: portrait)"
            />
            <source
              src="video/Hero-Landscape.mp4"
              type="video/mp4"
              media="(orientation: landscape)"
            />
          </video>
          <img src="bg/video-bg.png" alt="" className={styles.videoBgPlaceholder} />
        </div>
        <div className={styles.videoControls}>
          <button onClick={toggleVideoSound}>
            {muteVideo ? (
              <img
                alt="Volume off"
                height="21px"
                width="21px"
                src="icons/Volume_Off.svg"
              />
            ) : (
              <img
                alt="Volume on"
                height="21px"
                width="21px"
                src="icons/Volume_On.svg"
              />
            )}
          </button>
          {/* <button onClick={playHeroVideo}>
            {playVideo ? (
              <img alt="Pause" height="21px" width="21px" src="Pause.svg" />
            ) : (
              <img alt="Play" height="21px" width="21px" src="Play.svg" />
            )}
          </button> */}
        </div>
        {/* <button className={styles.scanCTA} onClick={handleScanNow}>
          SCAN NOW
        </button> */}
      </div>
    </div>
  );
}
